import * as React from 'react';
import { cn } from '@/lib/utils';

export type WfButtonVariant = 'default' | 'primary' | 'danger' | 'ghost' | 'promote' | 'instantiate';

export interface WfButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: WfButtonVariant;
}

/** Botão do wireframe (.btn + variantes primary/danger/ghost/promote/instantiate). */
export const WfButton = React.forwardRef<HTMLButtonElement, WfButtonProps>(
  ({ variant = 'default', className, type = 'button', children, ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn('wf-btn', variant !== 'default' && `wf-btn-${variant}`, className)}
      {...props}
    >
      {children}
    </button>
  )
);
WfButton.displayName = 'WfButton';
